import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../Form/Button';
import { useCartContext } from '../../../Contexts/CartContext';
import { HiXMark } from 'react-icons/hi2';
import { TbShoppingBagPlus } from 'react-icons/tb';
import { METHOD_PAYMENT_TYPE_PIX } from '../../../Utils/Constants/Checkout';
import ButtonPrimary from '../../Form/ButtonPrimary';
import { useStoreHook } from '../../../Hooks/StoreHook';

interface ButtonsCheckoutProps {
  disabledFinish: boolean;
  onFinishOrder: CallableFunction;
  onCancel: CallableFunction;
  label: string;
  method: any;
}

const ButtonsCheckout = ({
  disabledFinish,
  onFinishOrder,
  label,
  method,
  onCancel
}: ButtonsCheckoutProps) => {

  const navigate = useNavigate();
  const { setReturnToCheckout, loadingUpdateQuantity } = useCartContext();
  const { getLinkToHome } = useStoreHook();

  const handleFinishOrder = () => {
    onFinishOrder()
  }

  const handleAddProduct = () => {
    navigate(getLinkToHome())
    setReturnToCheckout(true)
  }

  // if (!method || method.type === METHOD_PAYMENT_TYPE_GOOGLE_PAY) return null;

  return (
    <>
      <Button onClick={handleAddProduct} className='text-sm text-nowrap gap-1 w-11 h-11 lg:w-auto lg:h-auto'>
        <div><TbShoppingBagPlus size={20} className='-mt-0.5' /></div>
        <span className='hidden lg:inline-block'>Produtos</span>
      </Button>

      <ButtonPrimary
        disabled={disabledFinish || loadingUpdateQuantity} onClick={() => handleFinishOrder()}
          className={`
            ${method?.type === METHOD_PAYMENT_TYPE_PIX && 'ring-teal-400 bg-teal-400 text-white hover:bg-teal-500 hover:ring-teal-500'}
            text-sm w-full xs:max-w-sm md:max-w-xs gap-1 text-nowrap`}
          >
          {label}
      </ButtonPrimary>

      <Button onClick={() => onCancel()} className='text-sm h-11 w-11'>
        <div><HiXMark size={20} /></div>
      </Button>
    </>
  )
}

export default ButtonsCheckout;